export default __webpack_public_path__ + "static/media/hrp-logo.20dc6248.svg";